import { render, staticRenderFns } from "./Covs.vue?vue&type=template&id=a6fe916e&scoped=true"
import script from "./Covs.vue?vue&type=script&lang=js"
export * from "./Covs.vue?vue&type=script&lang=js"
import style0 from "./Covs.vue?vue&type=style&index=0&id=a6fe916e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fe916e",
  null
  
)

export default component.exports